export const isValidZipcode = value =>
  /^\d{5}$|^\d{5}-\d{4}$/.test(value);
